module.exports = __webpack_public_path__ + "static/media/Get-in-touch-bro-green.91450b33.svg";